import React, { useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Label,
} from 'recharts';
import { Box } from '@mui/material';
import NumberFormat from 'react-number-format';

const RADIAN = Math.PI / 180;
const data = [
  { name: 'Vendas Recebidas', value: 40 },
  { name: 'Vendas a Receber', value: 20 },
  { name: 'Despesas Pagas', value: 10 },
  { name: 'Despesas a Pagar', value: 30 },
];

export default function CashGraph(props) {
  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx, cy, midAngle, outerRadius, value, fill,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const mx = cx + (outerRadius + 20) * cos;
    const my = cy + (outerRadius + 20) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill={fill}
          fontSize="18"
        >
          {`${value.toFixed(2)}%`}
        </text>
      </g>
    );
  };

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

  return (
    <ResponsiveContainer height={300}>
      <PieChart>
        <Pie data={data} dataKey="value" label={renderActiveShape}>
          {data.map((v, i) => (
            <Cell key={`${v.name}${i}`} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value) => (
            <NumberFormat
              value={value}
              displayType="text"
              suffix="%"
              decimalScale={2}
            />
          )}
        />
        <Legend
          layout="vertical"
          iconType="circle"
          verticalAlign="bottom"
          align="left"
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
